<template>
  <b-container fluid>
    <b-row>
      <b-col md="12">
        <div class="iq-card p-3 row">
          <div class="col-12 col-sm-6 col-md-6 col-lg-6">
            <h4>
              <i class="fa ri-question-answer-fill" aria-hidden="true" style="font-size: 21px; margin-right: 10px; color: var(--iq-primary);"></i>
              {{cvCardTitle}}
            </h4>
          </div>
          <div class="col-12 col-sm-6 col-md-6 col-lg-6 pr-0">
            <b-button class="right-align-sm mt-2 mb-1 mt-sm-0 ml-2" variant="primary" @click="gotoDashBoard()" v-if="userData.user_role=='USERROLE11111' || userData.user_role=='USERROLE11118'">App DashBoard</b-button>
            <!-- Test only (admin, non-prod): opens the new V1 quiz screen QuestionQuizFullPageV1 -->
            <b-button class="right-align-sm mt-2 mb-1 mt-sm-0 ml-2" variant="primary" style="background-color: #324dc7; border-color: #324dc7; color: #fff;" @click="detail_pagev1()">Play</b-button>
            <b-button class="right-align-sm mt-2 mb-1 mt-sm-0 ml-2" variant="primary" @click="detail_page()" v-if="userData.user_role=='USERROLE11111' || userData.user_role=='USERROLE11118'">Play</b-button>
            <b-button class="right-align-sm mt-2 mb-1 mt-sm-0 ml-2" variant="primary" @click="confirmQuizBankAdd">{{cvbtnAddNew}}</b-button>
          </div>
          <div class="col-12" :key="updated">
            <h5> Name: {{appDetails.app_name}}</h5>
            <h5><small>Id: {{appDetails.app_id}}</small></h5>
            <h6><small>App Type: <span>{{appDetails.app_type}}</span></small></h6>
            <h6><small>Category: <span>{{appDetails.app_category}}</span></small></h6><br/>
            <b-badge title="Show active questions only" :style="setTagStyles('active')" class="tags mr-2 mb-2 font-weight-normal" variant="none" @click="filterQuestions(0)">
              <span>Questions Active: <span>{{total_questions || 0}}</span></span>
            </b-badge>
            <b-badge title="Show Question that do not follow the exam/quiz standard" :style="setTagStyles('unconventional')" class="tags mr-2 mb-2 font-weight-normal" variant="none" @click="filterQuestions(3)">
              <span>Unconventional Questions: <span>{{unconventional_questions || 0}}</span></span>
            </b-badge>
            <b-badge title="Show deleted questions only" :style="setTagStyles('deleted')" class="tags mr-2 mb-2 font-weight-normal" variant="none" @click="filterQuestions(1)">
              <span>Questions Deleted: <span>{{total_questions_deleted || 0}}</span></span>
            </b-badge>
            <b-badge title="Show broken questions only" :style="setTagStyles('broken')" class="tags mr-2 mb-2 font-weight-normal" variant="none" @click="filterQuestions(4)">
              <span>Questions Broken: <span>{{broken_questions.length || 0}}</span></span>
            </b-badge>
            <b-button variant="mr-1 mb-1" @click="confirmBulkDelete(appDetails, true)" title="Soft Delete All Questions" class="delete_button">
              <i class="ri-delete-bin-line font-size-20" aria-hidden="true"></i>
            </b-button>
            <b-button v-if="isTrustedUser" variant="m-1 mb-1" @click="confirmBulkDelete(appDetails, false)" title="Hard Delete All Questions" class="delete_button ml-2">
              <i class="ri-delete-bin-2-fill font-size-20" aria-hidden="true"></i>
            </b-button>
            <b-button variant="mr-1 mb-1" @click="openChangeAppidModal()" title="Move questions to New App/Quiz" >
              <i class="fa-solid fa-arrows-rotate font-size-20"></i>
            </b-button>
             <b-button :disabled="isAnalyzingQuestions" variant="mr-1 mb-1" @click="quizBankAnalyzeAppQuizOptionsAndUpdateCorrectAnswers()" title="Analyse all Quiz Options and Correct Answers by AI" >
              <i class="fa-solid fa-robot font-size-20"></i>
            </b-button>
          </div>
        </div>
        <div class="iq-card row p-3">
          <b-col lg="10" class="mb-3">
            <div class="row">
              <b-col lg="9" xl="9">
                <input class="form-control mb-2"
                  id="search"
                  v-model="whereFilter.search_param"
                  type="search"
                  @input="searchUserWithParams"
                  :placeholder="cvSearchText"
                />
              </b-col>
              <b-col class="mb-2 col-6 col-sm-4">
                <select v-model="qbk_category" class="form-control" @change="setFilters" title="Choose Category">
                  <option :value="null" disabled>Choose Category</option>
                  <option value="">All</option>
                  <option v-for="(category, index) of quizBankFilterList['qbk_category']" :key="('qbk_category' + index + 1)" :value="category.qbk_category">
                    {{ category.qbk_category }}
                  </option>
                </select>
              </b-col>
              <b-col class="mb-2 col-6 col-sm-4">
                <select v-model="skill" class="form-control" @change="setFilters" title="Choose Category">
                  <option :value="null" disabled>Choose Category</option>
                  <option value="">All</option>
                  <option v-for="(category, index) of quizBankFilterList['skill']" :key="('skill' + index + 1)" :value="category.skill">
                    {{ category.skill }}
                  </option>
                </select>
              </b-col>
            </div>
          </b-col>
           <b-col class="col-12 col-sm-12 col-md-12 col-lg-2">
            <CsvDownload :propModuleFile="cvModuleFile" class="Download_button"/>
            <CsvUpload :propModulePrefix="cvModulePrefix" class="Download_button"/>
            <i v-if="quizBankObjList && quizBankObjList.length > 0" :csv-title="csvTitle" class="fa-solid fa-file-csv Download_button" title="Download CSV" @click="backendCsvDownload"></i>
          </b-col>
        </div>
        <div class="iq-card row p-3">
          <b-col class="container_minheight" md="12" v-if="quizBankObjList && quizBankObjList.length > 0">
            <b-table
              hover
              responsive
              :items="quizBankObjList"
              :fields="columns"
              :no-border-collapse="true"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :filter="filter"
              :filter-included-fields="filterOn"
              :current-page="currentBatchNo"
              :per-page="dataPerPage"
            >
              <template v-slot:cell(serial_no)="data">
                {{ data.item.serial_no }}
              </template>

              <template v-slot:cell(deleted)="data">
                <b-badge v-if="data.item.deleted == 1" style="background-color: #e5252c !important;">Deleted</b-badge>
                <b-badge v-else-if="data.item.deleted == 2" style="background-color: yellow !important;">UnPublished</b-badge>
                <b-badge v-else-if="data.item.deleted == 3" style="background-color: orange !important;">Unconventional</b-badge>
                <b-badge v-else style="background-color: green !important;">Active</b-badge>
                <span class="pointer" v-if="data.item.deleted == 3"><i class="fa-solid fa-clipboard-check mt-4 font-size-20 pointer" title="Activate this question. This action will only update the answer choices and correct answer." @click="activateQuestion(data.item)"></i></span>
              </template>

              <template v-slot:cell(qbk_id)="data">
                <span><small>Id: {{data.item.qbk_id}}</small></span><br><br>
                Q.Category: <span class="primary-color">{{ data.item.qbk_category }}</span><br>
                Skill: <span class="primary-color">{{ data.item.skill }}</span><br>
                Difficulty Level: <span class="primary-color">{{ data.item.difficulty }}</span><br><br>

                <b-button class="actionIcon mr-1 pointer" size="sm" @click="quizBankEdit('MODAL', data.item)" v-if="!data.item.editable"><i class="ri-ball-pen-fill font-size-20 m-0"></i></b-button>
                <b-button class="actionIcon mt-1 pointer" v-if="data.item.deleted == 0" @click="showQuestionBankDeleteDialog(data.item)" size="sm"><i class="ri-delete-bin-line m-0 font-size-20" title="Delete"></i></b-button>
                <b-button class="actionIcon mt-1 pointer" v-else @click="activateQuestion(data.item)" size="sm"><i class="fa-solid fa-clipboard-check m-0 font-size-20" title="Activate this question. This action will only update the answer choices and correct answer."></i></b-button>
                <b-button class="actionIcon mt-1 pointer" @click="quizQuestionview('MODAL', data.item)" ><i class="fa-solid fa-eye font-size-20" title="Horizontal View of Question"></i></b-button>
                <b-button class="actionIcon mt-1 pointer" @click="quizQuestionviewV1('MODAL', data.item)" ><i class="fa-solid fa-binoculars font-size-20" title="Vertical Live View of Question. In Production Right Now"></i></b-button>
                <b-button v-if="questionState !== 3" class="actionIcon mt-1 pointer" @click="quizbankGenAnsExplanation(data.item)" title="Solve Question via AI" ><i class="fa fa-quora font-size-20"></i></b-button>
                <b-button v-if="questionState !== 3" class="actionIcon mt-1 pointer" @click="quizQuestionAnalyse(data.item)" title="Analyse Question via AI" ><i class="fa fa-robot font-size-20"></i></b-button>
                <b-button v-if="questionState !== 3" class="actionIcon mt-1 pointer" @click="openChangeAppidModal(data.item.qbk_id)" title="Move questions to New App/Quiz" ><i class="fa-solid fa-arrows-rotate font-size-20"></i></b-button>
                <ChangeCategoryModal v-if="questionState !== 3" :propQuestionBankObj="data.item" @emitCloseChangeCategoryModal="quizBankList"/>
              </template>

              <template v-slot:cell(question)="data">
                <span @click="imgModal(data.item.question)" class="magnifying_glass">
                  <span v-html="data.item.question"></span>
                </span>
              </template>

              <template v-slot:cell(answer_choices)="data">
                <span><b>{{data.item.is_mcq ? "MCQ TYPE" : "ESSAY TYPE"}}</b></span><br>
                <span v-if="data.item.is_mcq && data.item.answer_choices && Object.keys(data.item.answer_choices).length > 0" v-html="replace_tags(data.item.answer_choices)"></span>
                <span v-else class="primary-color"><b>{{data.item.is_mcq ? "Missing Choices" : ""}}</b></span>
              </template>

              <template v-slot:cell(answer_explanation)="data">
                <span v-if="data.item.answer_explanation">
                  <span class="success-color"><b>Explanation Generated</b></span>
                  <b-button class="actionIcon mt-1" @click="quizQuestionview('MODAL', data.item)" ><i class="fa-solid fa-eye font-size-20"></i></b-button>
                </span>
                <span class="warning-color" v-else><b>Not Available</b></span>
              </template>
            </b-table>
          </b-col>
          <b-col class="container_minheight primary-color" md="12" v-else-if="quizBankObjList && quizBankObjList.length <= 0">
            No Question found. Click on Add Button to add questions.
          </b-col>
          <b-col class="container_minheight text-center primary-color" md="12" v-else>
            <b-spinner class="align-middle"></b-spinner>
          </b-col>
          <b-col sm="12" md="7">
            <b-btn variant="primary" @click="loadMoreData" v-if="showLoadMoreBtn">Load More</b-btn>
          </b-col>
          <b-col sm="5" md="4" class="my-1">
            <b-pagination
              v-model="currentBatchNo"
              :total-rows="totalRows"
              :per-page="dataPerPage"
              align="fill"
              size="sm"
              class="my-0"
            ></b-pagination>
          </b-col>
        </div>
      </b-col>
    </b-row>

    <b-modal
      v-model="showModelQuestionBankAdd"
      scrollable
      :title="cvAddModalHeader"
      size="xxl"
      >
      <QuizBankAdd :propAppCategory="appDetails.app_category" :propAppId="propAppId" :propOpenedInModal="true" @emitCloseQuestionBankAddModal="closeQuestionBankAddModal" />
      <template #modal-footer="">
        <b-button size="sm" class="pull-left" @click="quizBankAdd('FULLPAGE')">
          {{cvbtnModalExpand}}
        </b-button>
        <b-button size="sm" @click="closeQuestionBankAddModal()">
          {{cvbtnModalCancel}}
        </b-button>
      </template>
    </b-modal>

    <b-modal
      v-model="showModelQuestionBankEdit"
      scrollable
      :title="cvEditModalHeader"
      size="xxl"
    >
      <QuizBankEdit :propQuestionState="questionState" :propOpenedInModal="true" :propQuestionBankObj="quizBankEditObj" @emitCloseQuestionBankEditModal="closeQuestionBankEditModal" />
      <template #modal-footer="">
        <b-button size="sm" class="pull-left" @click="quizBankEdit('FULLPAGE')">
          {{cvbtnModalExpand}}
        </b-button>
        <b-button size="sm" @click="closeQuestionBankEditModal()">
          {{cvbtnModalCancel}}
        </b-button>
      </template>
    </b-modal>

    <b-modal
      v-model="showModelQuestionQuizView"
      scrollable
      :title="cvViewModalHeader"
      size="xxl"
    >
      <QuestionQuizView :propQuestionState="questionState" :propOpenedInModal="true" :propQuestionBankObj="QuestionQuizViewObj" @emitCloseQuestionQuizViewModal="closeQuestionQuizViewModal" />
      <template #modal-footer="">
        <b-button size="sm" class="pull-left" @click="quizQuestionview('FULLPAGE')">
          {{cvbtnModalExpand}}
        </b-button>
        <b-button size="sm" @click="closeQuestionQuizViewModal()">
          {{cvbtnModalCancel}}
        </b-button>
      </template>
    </b-modal>

    <b-modal
      v-model="showModelQuestionQuizViewV1"
      scrollable
      :title="cvViewModalHeaderV1"
      size="xxl"
    >
      <QuestionQuizViewV1 :propQuestionState="questionState" :propOpenedInModal="true" :propQuestionBankObj="QuestionQuizViewObj" @emitCloseQuestionQuizViewModal="closeQuestionQuizViewModalV1" />
      <template #modal-footer="">
        <b-button size="sm" class="pull-left" @click="quizQuestionviewV1('FULLPAGE')">
          {{cvbtnModalExpand}}
        </b-button>
        <b-button size="sm" @click="closeQuestionQuizViewModalV1()">
          {{cvbtnModalCancel}}
        </b-button>
      </template>
    </b-modal>

    <b-modal v-model="showModelQuestionBankDelete" size="sm" title="Delete" ok-title="Delete" cancel-title="Cancel">
      <p>{{cvDelMessage}}</p>
      <template #modal-footer="">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="showModelQuestionBankDelete = false">
          {{cvbtnModalCancel}}
        </b-button>
        <b-button size="sm" variant="primary" @click="quizBankDelete()">
          {{cvbtnModalDelOk}}
        </b-button>
      </template>
    </b-modal>

    <b-modal
      v-model="showModelImageView"
      scrollable
      size="xxl"
      >
      <image-view :propImageUrl="propImageUrl"/>
    </b-modal>

    <b-modal
      v-model="showChangeAppidModal"
      scrollable
      :title="cvViewModalHeaderMoveQuestion"
      size="xxl"
    >
      <ChangeAppidModal :propAppDetails="appDetails" @emitCloseChangeAppidModal="closeChangeAppidModal"/>
      <template #modal-footer="">
        <b-button size="sm" @click="closeChangeAppidModal">
          {{cvbtnModalCancel}}
        </b-button>
      </template>
    </b-modal>

    <b-modal v-model="showModelQuestionBankBulkDelete" size="sm" title="Confirm Delete">
      <p v-if="isTrustedUser">{{ cvDelMessage }} (Soft Delete)</p>
      <p v-else class="text-danger"><strong>Warning:</strong> This will permanently hard delete all questions. This action cannot be undone!</p>
        <template #modal-footer>
            <b-button size="sm" @click="showModelQuestionBankBulkDelete = false; currentAppToDelete = null">
            {{ cvbtnModalCancel }}
            </b-button>
            <b-button v-if="isTrustedUser" size="sm" :variant="isTrustedUser ? 'primary' : 'danger'" @click="deleteBulkQuizQuestions(currentAppToDelete, true)">
            {{ cvbtnModalDelOk }}
            </b-button>
             <b-button v-else size="sm" :variant="isTrustedUser ? 'primary' : 'danger'" @click="deleteBulkQuizQuestions(currentAppToDelete, false)">
            {{ cvbtnModalDelOk }}
            </b-button>
        </template>
    </b-modal>

    <b-toast v-model="showToast" name="Toast" :variant="toastVariant" :title="toastTitle">
      <div v-html="toastMsg"></div>
    </b-toast>
    <AlertBox :propAlertTitle="alertTitle" v-if="showAlertBox" :propAlertDesc="alertDesc" :propOkBtnText="okText" @emitCloseAlertModel="showAlertBox = false" @emitConfirmAlertModel="quizBankAdd" :propCancelBtnText="cancelText" />
  </b-container>
</template>

<script>
import { QuizBanks } from "../../../FackApi/api/quizBank.js"
import QuizBankAdd from "./QuizBankAdd.vue"
import QuizBankEdit from "./QuizBankEdit.vue"
import QuestionQuizView from "../../Gide/QuizBank/QuestionQuizView.vue"
import QuestionQuizViewV1 from "../../Gide/QuizBank/QuestionQuizViewV1.vue"
import moment from "moment"
import ApiResponse from "../../../Utils/apiResponse.js"
import CsvUpload from "../../../components/Csv/CsvUpload.vue"
import CsvDownload from "../../../components/Csv/CsvDownload.vue"
import { Apps } from "../../../FackApi/api/apps.js"
import { socialvue } from "../../../config/pluginInit.js"
import userPermission from "../../../Utils/user_permission"
import ImageView from "./ImageView.vue"
import ChangeCategoryModal from "./ChangeCategoryModal.vue"
import ChangeAppidModal from "../Apps/ChangeAppidModal.vue"
import AlertBox from "../../../components/AlertBox.vue"
import appDomain from "../../../FackApi/json/Domain.json"

export default {
  name: "QuestionBankList",
  components: {
    QuizBankAdd,
    QuizBankEdit,
    CsvDownload,
    CsvUpload,
    QuestionQuizView,
    QuestionQuizViewV1,
    ImageView,
    ChangeCategoryModal,
    ChangeAppidModal,
    AlertBox
  },
  data () {
    return {
      apiName: "quiz_bank_list",
      VUE_APP_TRUSTED_EMAILS: process.env.VUE_APP_TRUSTED_EMAILS,
      VUE_APP_ENV: process.env.VUE_APP_ENV,
      cvCardTitle: "Question Bank",
      cvbtnAddNew: "Add",
      cvSearchText: "Type to Search",
      cvbtnModalDelOk: "Delete",
      cvDelMessage: "Are you sure?",
      cvEditModalHeader: "Edit Question",
      cvAddModalHeader: "Add Question",
      cvViewModalHeader: "View Question",
      cvViewModalHeaderV1: "View Question",
      cvViewModalHeaderMoveQuestion: "Move All Questions to New App",
      cvbtnModalCancel: "Cancel",
      cvbtnModalExpand: "Expand",
      showToast: false,
      toastMsg: null,
      toastVariant: "default",
      toastTitle: "Question Bank List",
      showModelQuestionBankAdd: false,
      showModelQuestionBankEdit: false,
      showModelQuestionQuizView: false,
      showModelQuestionQuizViewV1: false,
      showModelQuestionBankDelete: false,
      showModelQuestionBankBulkDelete: false,
      showModelImageView: false,
      showChangeAppidModal: false,
      sortBy: "name",
      sortDesc: false,
      columns: [
        { label: "# ", key: "id", class: "text-left align-text-top", sortable: true },
        { label: "Serial no", key: "serial_no", class: "text-left align-text-top w-150px", sortable: true },
        { label: "Status", key: "deleted", class: "text-left align-text-top", sortable: true },
        { label: "Question Id ", key: "qbk_id", class: "text-left align-text-top w-300px", sortable: false },
        { label: "Question", key: "question", class: "text-left align-text-top w-300px", sortable: true },
        { label: "Answer Choices", key: "answer_choices", class: "text-left align-text-top w-350px", sortable: true },
        { label: "Correct Answers", key: "correct_answers", class: "text-left align-text-top", sortable: true },
        { label: "Question Marks", key: "question_points", class: "text-left align-text-top", sortable: true },
        { label: "Answer Explanation", key: "answer_explanation", class: "text-left align-text-top", sortable: true },
        { label: "Why Unconventional ?", key: "is_standard_reason", class: "text-left align-text-top w-300px", sortable: true }
      ],
      quizBankObjList: [],
      quizBankEditObj: null,
      QuestionQuizViewObj: null,
      filter: null,
      filterOn: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 50,
      delObj: null,
      cvModuleFile: "app_quiz_bank",
      cvModulePrefix: "qbk",
      quizResData: [],
      answerChoiceArr: [],
      appDetails: {},
      total_questions: 0,
      unconventional_questions: 0,
      total_questions_deleted: 0,
      broken_questions: 0,
      propImageUrl: null,
      propAppId: null,
      currentBatchNo: 1,
      dataPerPage: 25,
      showLoadMoreBtn: true,
      questionState: null, // 0 -> active, 1 -> deleted, 3 -> unconventional
      csvTitle: "QuestionBankList",
      whereFilter: {
        search_param: ""
      },
      isTrustedUser: false,
      updated: 0,
      isAnalyzingQuestions: false,
      alertTitle: "Question Bank",
      alertDesc: "You are adding a new question to this app, which might affect the total questions and the total score of the app",
      okText: "Proceed",
      cancelText: "Cancel",
      showAlertBox: false,
      appDomain: appDomain,
      qbk_category: "",
      skill: "",
      currentAppToDelete: null,
      vmqbkcategoryList: []
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    }
  },
  beforeMount () {
    // Auth Access for Current User Role
    if (!userPermission(this, this.userData, this.apiName)) {
      this.$router.back()
    }
  },
  async mounted () {
    socialvue.index()
    if (this.$route.params.app_id) {
      this.app_id = this.$route.params.app_id
      this.appView()
    }
    await this.quizBankFilterList("skill")
    await this.quizBankFilterList("qbk_category")
    this.quizBankList()

    // setting isTrustedUser for hard delete
    const allowedEmails = (process.env.VUE_APP_TRUSTED_EMAILS ?? "").toLowerCase()?.split(",")
    this.isTrustedUser = allowedEmails.includes(this.userData.user_email.toLowerCase())
  },
  methods: {
    /**
     * gotoDashBoard
     */
    gotoDashBoard () {
      this.$router.push(`../quiz_list`)
    },
    /**
     * Opens the confirmation modal and saves the target item data
     *
    */
    confirmBulkDelete (appDetails, softDelete = true) {
      this.currentAppToDelete = appDetails
      this.isTrustedUser = softDelete
      this.showModelQuestionBankBulkDelete = true
    },
    /**
     * deleteBulkQuizQuestions
     */
    async deleteBulkQuizQuestions (appDetails, softDelete = true) {
      if (!this.isTrustedUser) {
        console.warn("Process stopped: User is not authrised.")
        return
      }

      try {
        const deleteObj = {}
        // Now we delete the questions of quizes using app_id only
        deleteObj.app_id = appDetails.app_id

        deleteObj.soft_delete = softDelete

        const bulDeleteResp = await QuizBanks.quizBankBulkDelete(this, deleteObj)
        ApiResponse.responseMessageDisplay(this, bulDeleteResp)
      }
      catch (err) {
        console.error("Exception in deleteQuizQuestions and err: ", err)
      }
    },
    /**
     * gotoDashBoard
     */
    detail_page () {
      this.$router.push(`../quiz_detail/${this.app_id}`)
    },
    /**
     * detail_pagev1 - Test only: opens the new V1 quiz screen QuestionQuizFullPageV1
     */
    detail_pagev1 () {
      this.$router.push(`/assessment/quizv1/${this.app_id}`)
    },
    /**
     * searchUserWithParams
     */
    async searchUserWithParams () {
      if (this.whereFilter.search_param.length <= 3) {
        return
      }
      await this.quizBankList()
    },
    /**
     * getFormattedDateTime
     */
    getFormattedDateTime (datetime) {
      try {
        return moment(datetime).format("DD-MM-YYYY hh:mm:ss")
      }
      catch (err) {
        console.log("Exception occurred at getFormattedDateTime() and Exception:", err.message)
      }
    },
    replace_tags (choices) {
      for (let k in choices) {
        choices[k] = choices[k].replace(/<p>/g, "").replace(/<\/p>/g, "")
      }
      return choices
    },
    /**
     * appView
     */
    async appView () {
      try {
        const appViewResp = await Apps.appView(this, this.app_id)
        if (!appViewResp.resp_status) {
          ApiResponse.responseMessageDisplay(this, appViewResp)
        }
        this.appDetails = appViewResp.resp_data.data
      }
      catch (err) {
        console.error("Exception in appView()")
      }
    },
    /**
     * quizBankList
     */
    async quizBankList (loadViaLoadMore = false, downloadCsv = false) {
      try {
        if (!loadViaLoadMore) {
          this.currentBatchNo = 1
          this.showLoadMoreBtn = true
        }

        const payload = {
          app_id: this.$route.params.app_id,
          search_param: this.whereFilter.search_param,
          admin_console: 1
        }

        // questionState:
        // null → non-deleted (deleted != 1) from app_quiz_bank
        // 0 → active from app_quiz_bank
        // 1 → deleted from app_quiz_bank
        // 3 → unconventional from app_quiz_bank_ai
        // 4 → Broken questions
        if (this.questionState != null && this.questionState != 4) {
          payload.question_state = this.questionState
        }

        // setting data for pagination
        payload.currentBatchNo = this.currentBatchNo
        payload.dataPerPage = this.dataPerPage
        payload.qbk_category = this.qbk_category
        payload.skill = this.skill

        payload.downloadCsv = downloadCsv
        if (this.$route.path.includes("quizBank_list")) {
          payload.is_management_panel = true
        }

        if (this.questionState == 4) {
          payload.questionIds = this.broken_questions
        }

        let isDashboard = true
        let quizBankListResp = await QuizBanks.quizBankListConsole(this, payload, isDashboard)
        if (quizBankListResp.resp_status) {
          if (downloadCsv) {
            window.open(quizBankListResp.resp_csv_file_url)
            return
          }

          if (loadViaLoadMore) {
            this.quizBankObjList = [...this.quizBankObjList, ...quizBankListResp.resp_data.data]
            this.quizResData = this.quizBankObjList
          }
          else {
            this.quizBankObjList = quizBankListResp.resp_data.data
            this.quizResData = this.quizBankObjList
          }

          this.totalRows = quizBankListResp.resp_data.count || this.quizBankObjList.length || 1

          if (quizBankListResp.resp_data.question_status_count_list != 0 || quizBankListResp.resp_data.question_status_count_list != "0") {
            this.total_questions = quizBankListResp.resp_data.question_status_count_list["id0"]
            this.total_questions_deleted = quizBankListResp.resp_data.question_status_count_list["id1"]
            // this.unpublished_questions = quizBankListResp.resp_data.question_status_count_list["id2"]
            this.unconventional_questions = quizBankListResp.resp_data.question_status_count_list["id3"]

            if (quizBankListResp.resp_data.question_status_count_list["id4"].length > 0) {
              this.broken_questions = quizBankListResp.resp_data.question_status_count_list["id4"]
            }
          }
        }
        else {
          this.showLoadMoreBtn = false
          this.currentBatchNo = 1
          this.totalRows = 1
          this.quizBankObjList = []
        }

        this.updated += 1
      }
      catch (err) {
        console.error("Exception occurred at quizBankList() and Exception:", err.message)
        this.quizBankObjList = []
      }
    },
    /**
     * imgModal
     */
    imgModal (quesObj) {
      try {
        this.propImageUrl = quesObj
        this.showModelImageView = true
      }
      catch (err) {
        console.error("Exception occurred at ImageView() and Exception:", err.message)
      }
    },
    /**
     * setTagStyles
     */
    setTagStyles (questionType) {
      let styles = "cursor:pointer;font-size:1rem;"
      if (questionType == "active" && this.questionState == 0) {
        styles += "background-color:#109618;color:#fff;"
      }
      else if (questionType == "active") {
        styles += "border:1px solid #109618;color:#109618;"
      }

      if (questionType == "deleted" && this.questionState == 1) {
        styles += "background-color:#e5252c;color:#fff;"
      }
      else if (questionType == "deleted") {
        styles += "border:1px solid #e5252c;color:#e5252c;"
      }

      if (questionType == "unconventional" && this.questionState == 3) {
        styles += "background-color:orange;color:#fff;"
      }
      else if (questionType == "unconventional") {
        styles += "border:1px solid orange;color:orange;"
      }

      if (questionType == "broken" && this.questionState == 4) {
        styles += "background-color:grey;color:#fff;"
      }
      else if (questionType == "broken") {
        styles += "border:1px solid grey;color:grey;"
      }

      return styles
    },
    /**
     * filterQuestions
     */
    async filterQuestions (questionState) {
      try {
        this.questionState = questionState
        this.currentBatchNo = 1
        this.showLoadMoreBtn = true
        this.quizBankList()
      }
      catch (err) {
        console.error("Exception in filterQuestions and err: ", err)
      }
    },
    /**
     * confirmQuizBankAdd
     */
    confirmQuizBankAdd () {
      this.showAlertBox = true
    },
    /**
     * quizBankAdd
     */
    quizBankAdd (type) {
      try {
        this.showAlertBox = false
        if (type === "FULLPAGE") {
          this.$router.push(`/quizBank_add/${this.app_id}`)
        }
        else {
          this.propAppId = this.$route.params.app_id
          this.showModelQuestionBankAdd = true
        }
      }
      catch (err) {
        console.error("Exception occurred at quizBankAdd() and Exception:", err.message)
      }
    },
    /**
     * quizBankEdit
     */
    quizBankEdit (type, item) {
      try {
        if (type === "FULLPAGE") {
          if (this.questionState && this.questionState === 3) {
            this.$router.push(`/quizBank_edit/${this.quizBankEditObj.qbk_id}/${this.questionState}`)
          }
          else {
            this.$router.push("/quizBank_edit/" + this.quizBankEditObj.qbk_id)
          }
        }
        else {
          this.quizBankEditObj = item
          this.showModelQuestionBankEdit = true
        }
      }
      catch (err) {
        console.error("Exception occurred at quizBankEdit() and Exception:", err.message)
      }
    },
    /**
    * quizQuestionview
    */
    quizQuestionview (type, item) {
      try {
        if (type === "FULLPAGE") {
          if (this.questionState && this.questionState === 3) {
            window.open("/quiz_question_view/" + this.QuestionQuizViewObj.qbk_id + "/" + this.questionState, "_blank")
          }
          else {
            window.open("/quiz_question_view/" + this.QuestionQuizViewObj.qbk_id, "_blank")
          }
        }
        else {
          this.QuestionQuizViewObj = item
          this.showModelQuestionQuizView = true
        }
      }
      catch (err) {
        console.error("Exception occurred at quizQuestionview() and Exception:", err.message)
      }
    },
    /**
    * quizQuestionviewv1
    */
    quizQuestionviewV1 (type, item) {
      try {
        if (type === "FULLPAGE") {
          if (this.questionState && this.questionState === 3) {
            window.open("/quiz_question_view/" + this.QuestionQuizViewObj.qbk_id + "/" + this.questionState, "_blank")
          }
          else {
            window.open("/quiz_question_view/" + this.QuestionQuizViewObj.qbk_id, "_blank")
          }
        }
        else {
          this.QuestionQuizViewObj = { ...item, appDetails: this.appDetails }
          this.showModelQuestionQuizViewV1 = true
        }
      }
      catch (err) {
        console.error("Exception occurred at quizQuestionviewV1() and Exception:", err.message)
      }
    },
    /**
     * showQuestionBankDeleteDialog
     */
    showQuestionBankDeleteDialog (item) {
      try {
        this.delObj = item
        this.showModelQuestionBankDelete = true
      }
      catch (err) {
        console.error("Exception occurred at showQuestionBankDeleteDialog() and Exception:", err.message)
      }
    },
    /**
     * activateQuestion
     */
    async activateQuestion (question) {
      try {
        // update answer_choices and correct_answers in app_quiz_bank and set deleted = 0 in app_quiz_bank_ai

        const qbkEditResp = await QuizBanks.quizBankEdit(this, { qbk_id: question.qbk_id, deleted: 0, answer_choices: question.answer_choices, correct_answers: question.correct_answers, activateQuestion: true })
        ApiResponse.responseMessageDisplay(this, qbkEditResp)
        if (qbkEditResp.resp_status) {
          this.appView()
          this.quizBankList()
        }
      }
      catch (err) {
        console.error("Exception in activateQuestion() and err: ", err.message)
      }
    },
    /**
     * quizBankDelete
     */
    async quizBankDelete () {
      try {
        // questionState decides delete table (3 → app_quiz_bank_ai, else → app_quiz_bank)
        const deleteObj = {
          qbk_id: this.delObj.qbk_id,
          is_mcq: this.delObj.is_mcq,
          questionState: this.questionState,
          question_points: this.delObj.question_points,
          app_id: this.appDetails.app_id
        }

        let quizBankDelResp = await QuizBanks.quizBankDelete(this, deleteObj)
        await ApiResponse.responseMessageDisplay(this, quizBankDelResp)

        if (quizBankDelResp && !quizBankDelResp) {
          this.showModelQuestionBankDelete = false
          return false
        }

        let index = this.quizBankObjList.indexOf(this.delObj)
        this.quizBankObjList.splice(index, 1)
        this.totalRows = this.totalRows - 1
        this.total_questions--
        this.showModelQuestionBankDelete = false
      }
      catch (err) {
        console.error("Exception occurred at quizBankDelete() and Exception:", err.message)
      }
    },
    /**
     * closeQuestionBankAddModal
     */
    closeQuestionBankAddModal (quizBankAddData) {
      try {
        if (quizBankAddData) {
          if (this.quizBankObjList && this.quizBankObjList.length >= 1) {
            let qbkObjLength = this.quizBankObjList.length
            let lastId = this.quizBankObjList[qbkObjLength - 1]["id"]
            quizBankAddData.id = lastId + 1
          }
          else {
            this.quizBankObjList = []
            quizBankAddData.id = 11111
          }

          quizBankAddData.created_on = moment()
          this.quizBankObjList.unshift(quizBankAddData)
          this.totalRows = this.totalRows + 1
          this.total_questions++
        }

        this.showModelQuestionBankAdd = false
        this.quizBankList()
      }
      catch (err) {
        console.error("Exception occurred at closequizBankAddModal() and Exception:", err.message)
      }
    },
    /**
     * closeQuestionBankEditModal
     */
    closeQuestionBankEditModal () {
      try {
        this.showModelQuestionBankEdit = false
        this.quizBankList()
      }
      catch (err) {
        console.error("Exception occurred at closeQuestionBankEditModal() and Exception:", err.message)
      }
    },
    /**
     * closeQuestionQuizViewModal
     */
    closeQuestionQuizViewModal () {
      this.showModelQuestionQuizView = false
    },
    /**
     * closeQuestionQuizViewModalV1
     */
    closeQuestionQuizViewModalV1 () {
      this.showModelQuestionQuizViewV1 = false
    },
    /**
     * loadMoreData
     */
    async loadMoreData () {
      this.currentBatchNo = this.currentBatchNo + 1
      this.quizBankList(true)
    },
    /**
     * quizQuestionAnalyse
     */
    async quizQuestionAnalyse (qbkDetails) {
      try {
        const payload = {
          qbk_id: qbkDetails.qbk_id
        }

        const analyseResp = await QuizBanks.quizBankQuizQuestionAnalyse(this, payload)
        ApiResponse.responseMessageDisplay(this, analyseResp)
      }
      catch (err) {
        console.error("Exception in quizQuestionAnalyse() and err: ", err.message)
      }
    },
    /**
     * quizbankGenAnsExplanation
     */
    async quizbankGenAnsExplanation (questionData) {
      try {
        const solveObj = {
          qbk_id: questionData.qbk_id,
          question: questionData.question,
          answer_choices: JSON.stringify(questionData.answer_choices),
          image: questionData.image
        }

        let quizSolveResp = await QuizBanks.quizBankSolve(this, solveObj)
        if (!quizSolveResp.resp_status) {
          this.toastMsg = quizSolveResp.resp_msg
          this.toastVariant = "danger"
          this.showToast = true
          return
        }
        this.toastMsg = quizSolveResp.resp_msg
        this.toastVariant = "success"
        this.showToast = true
      }
      catch (err) {
        console.error("Exception in quizbankGenAnsExplanation and err: ", err)
      }
    },
    /**
     * backendCsvDownload
     */
    async backendCsvDownload () {
      this.quizBankList(false, true)
    },
    /**
     * Open Change Appid Modal
     */
    openChangeAppidModal (qbkId = null) {
      this.appDetails.qbk_id = qbkId
      this.showChangeAppidModal = true
    },
    /**
     * close Change Appid Modal
     */
    closeChangeAppidModal () {
      this.showChangeAppidModal = false
      this.appDetails.qbk_id = null
      this.appView()
      this.quizBankList()
    },
    /**
     * quizBankAnalyzeAppQuizOptionsAndUpdateCorrectAnswers
     */
    async quizBankAnalyzeAppQuizOptionsAndUpdateCorrectAnswers () {
      try {
        this.isAnalyzingQuestions = true
        let payload = {}
        if (this.appDetails.app_id) {
          payload.app_id = this.appDetails.app_id
        }
        else {
          this.showToast = true
          this.toastMsg = "App ID is required"
          this.toastVariant = "danger"
        }
        const analyzeResp = await QuizBanks.quizBankAnalyzeAppQuizOptionsAndUpdateCorrectAnswers(this, payload)
        ApiResponse.responseMessageDisplay(this, analyzeResp)
        setTimeout(() => {
          this.isAnalyzingQuestions = false
          this.quizBankList()
        }, 60000)
      }
      catch (err) {
        console.error("Exception in quizBankAnalyzeAppQuizOptionsAndUpdateCorrectAnswers and err: ", err)
        this.isAnalyzingQuestions = false
      }
    },
    /*
     * quizBankFilterList
     */
    async quizBankFilterList (filterName = null) {
      if (!filterName) {
        return
      }
      let payload = {}
      if (this.app_id) {
        payload.app_id = this.app_id
      }
      try {
        let quizFilterListResp = await QuizBanks.quizBankFilterList(this, filterName, payload)
        if (quizFilterListResp) {
          this.quizBankFilterList[filterName] = quizFilterListResp.resp_data
        }
      }
      catch (err) {
        console.error("Exception occurred at blog_filter_list_resp() and Exception:", err.message)
      }
    },
    /**
     * setFilters
    */
    async setFilters (filterType = null) {
      if (filterType === "domain") {
        this.qbk_category = ""
      }

      await this.quizBankFilterList("qbk_category")
      await this.quizBankList()
    }
  }
}
</script>
<style scoped>
.delete_button{
  color: #e5252c;
  border: 1px solid;
  padding: 0px 10px;
  padding-right: 7px;
}
.card-title{
  display: block !important;
}
.btn_in_header{
  float: right;
  display: unset;
}
</style>
